export const MaxSupplyOverwrite: Record<string, number | undefined> = {
  "digital-reserve-currency": 1000000000,
};
